import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row full-width" }
const _hoisted_2 = { class: "col-12" }

import { AnalysisItem } from '@/models/analysis-item';
import { api } from '@/utils';
import Create from './Create.vue';
import Edit from './Edit.vue';
import List from './List.vue';
import { plainToInstance } from 'class-transformer';
import { ref } from 'vue';
import { tableColumns } from './table-columns';
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import View from './View.vue';

// import Disable from './Disable.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const quasar = useQuasar();

const searchWord = ref<string>('');
const analysisItems = ref<AnalysisItem[]>([]);
const selectedAnalysisItem = ref<AnalysisItem | null>(null);

const modalCreate = ref<InstanceType<typeof Create> | null>(null);
const modalEdit = ref<InstanceType<typeof Edit> | null>(null);
const modalView = ref<InstanceType<typeof View> | null>(null);
const modalList = ref<InstanceType<typeof List> | null>(null);
// const modalDisable = ref<InstanceType<typeof Disable> | null>(null);

const getAnalysisItems = () => {
  quasar.loading.show();

  api
    .get('analysis-item')
    .then((response) => {
      analysisItems.value = plainToInstance(AnalysisItem, response.data);
      quasar.loading.hide();
    })
    .catch((error) => {
      quasar.notify({
        type: 'negative',
        message: 'Houve um problema ao adquirir as informações dos itens de análise.',
      });
      console.log('Erro ao adquirir dados dos itens de análise', error.response);
      quasar.loading.hide();
    });
};

const edit = (id: number) => {
  selectedAnalysisItem.value =
    analysisItems.value.find((analysisItem) => analysisItem.id === id) || null;

  setTimeout(() => {
    modalEdit.value?.open();
  }, 250);
};

const view = (id: number) => {
  selectedAnalysisItem.value =
    analysisItems.value.find((analysisItem) => analysisItem.id === id) || null;

  setTimeout(() => {
    modalView.value?.open();
  }, 250);
};

const list = () => {
  setTimeout(() => {
    modalList.value?.open();
  }, 250);
};

// const disable = (id: number) => {
//   selectedAnalysisItem.value = analysisItems.value.find((analysisItem) => analysisItem.id === id) || null;

//   setTimeout(() => {
//     modalDisable.value?.open();
//   }, 250);
// };

const init = () => {
  getAnalysisItems();
};

init();

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_q_table, {
          title: "Itens de Análise",
          rows: analysisItems.value,
          "row-key": "id",
          columns: _unref(tableColumns),
          filter: searchWord.value,
          "rows-per-page-options": [10, 50, 100, 200, 0],
          class: ""
        }, {
          "top-right": _withCtx(() => [
            _createVNode(_component_q_input, {
              borderless: "",
              dense: "",
              debounce: "300",
              modelValue: searchWord.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchWord).value = $event)),
              placeholder: "Pesquisar"
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, { name: "search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_btn, {
              label: "Novo",
              color: "primary",
              class: "q-ml-xl",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (modalCreate.value?.open()))
            }),
            _createVNode(_component_q_btn, {
              label: "Reordenar Itens",
              color: "primary",
              class: "q-ml-xl",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (modalList.value?.open()))
            })
          ]),
          "body-cell-actions": _withCtx((props) => [
            _createVNode(_component_q_td, { props: props }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  flat: "",
                  size: "sm",
                  round: "",
                  color: "primary",
                  icon: "visibility",
                  onClick: ($event: any) => (view(props.row.id))
                }, null, 8, ["onClick"]),
                _createVNode(_component_q_btn, {
                  flat: "",
                  size: "sm",
                  round: "",
                  color: "primary",
                  icon: "edit",
                  onClick: ($event: any) => (edit(props.row.id))
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 1
        }, 8, ["rows", "columns", "filter"])
      ])
    ]),
    _createVNode(Create, {
      ref_key: "modalCreate",
      ref: modalCreate,
      analysisItems: analysisItems.value,
      onCreated: _cache[3] || (_cache[3] = ($event: any) => (getAnalysisItems()))
    }, null, 8, ["analysisItems"]),
    _createVNode(Edit, {
      ref_key: "modalEdit",
      ref: modalEdit,
      analysisItems: analysisItems.value,
      analysisItem: selectedAnalysisItem.value,
      onSaved: getAnalysisItems
    }, null, 8, ["analysisItems", "analysisItem"]),
    _createVNode(View, {
      ref_key: "modalView",
      ref: modalView,
      analysisItem: selectedAnalysisItem.value
    }, null, 8, ["analysisItem"]),
    _createVNode(List, {
      ref_key: "modalList",
      ref: modalList,
      analysisItems: analysisItems.value
    }, null, 8, ["analysisItems"])
  ], 64))
}
}

})